const NAME = "ASSETS_DISCOUNTS_ENTRY_BY_INSTALLMENTS";

export default NAME;
